export const ladderDefaults = [
  {
    value: "geneRuler1KB",
    label: "GeneRuler 1kb + DNA 75-20,000 bp",
    markings: [
      2e4,
      1e4,
      7e3,
      5e3,
      4e3,
      3e3,
      2e3,
      1500,
      1e3,
      700,
      500,
      400,
      300,
      200,
      75
    ]
  },
  {
    value: "geneRuler100BP",
    label: "GeneRuler 100bp + DNA 100-3000 bp",
    markings: [
      3e3,
      2e3,
      1500,
      1200,
      1e3,
      900,
      800,
      700,
      600,
      500,
      400,
      300,
      200,
      100
    ]
  },
  {
    value: "invitrogen1KbPlus",
    label: "Invitrogen 1kb + DNA 100-15,000 bp",
    markings: [
      15e3,
      1e4,
      8e3,
      7e3,
      6e3,
      5e3,
      4e3,
      3e3,
      2e3,
      1500,
      1e3,
      850,
      650,
      500,
      400,
      300,
      200,
      100
    ]
  }
];
